/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBracketsSquare: {
  name: 'brackets-square';
  data: string;
} = {
  name: 'brackets-square',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 0-1H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h2a.5.5 0 0 0 0-1H2a.5.5 0 0 1-.5-.5V2ZM12 .5a.5.5 0 0 0 0 1h2.25c.042 0 .097.018.15.082.056.064.1.166.1.293v12.25c0 .127-.044.23-.1.293-.053.064-.108.082-.15.082H12a.5.5 0 0 0 0 1h2.25c.76 0 1.25-.69 1.25-1.375V1.875C15.5 1.191 15.01.5 14.25.5H12Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
